export interface CountryModel {
  code: string;
  id: string;
  name: string;
  utcInsertDate: string;
  utcUpdateDate: string;
  version: string;
}

export class Country {
  code = "";
  id = "";
  name = "";
  utcInsertDate = "";
  utcUpdateDate = "";
  version = "";

  constructor(dto?: CountryModel) {
    if (!dto) {
      return;
    }
    this.code = dto.code;
    this.id = dto.id;
    this.name = dto.name;
    this.utcInsertDate = dto.utcInsertDate;
    this.utcUpdateDate = dto.utcUpdateDate;
    this.version = dto.version;
  }
}
